<div class="flex flex-col max-w-240 md:min-w-200 max-h-screen -m-6">

    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{dialogTitle}}</div>
        <button mat-icon-button (click)="onClose()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>


    <form class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto" [formGroup]="generateReportForm">
        <fuse-alert [appearance]="'soft'" *ngIf="alert" [dismissible]="true" [dismissed]="false" [type]="alert.type">
            {{alert.message}}
        </fuse-alert>

        <div class="w-full md:mb-0 pb-2">
            <mat-radio-group class="flex" [color]="'primary'" [formControlName]="'templateType'" appearance="outline"
                (change)="onCheckBoxSelection()">
                <mat-radio-button value="all">All</mat-radio-button>
                <mat-radio-button class="pl-2" value="report">Report</mat-radio-button>
                <mat-radio-button class="pl-2" value="visitSheet">VisitSheet</mat-radio-button>
                <mat-radio-button class="pl-2" value="summary">Summary</mat-radio-button>
            </mat-radio-group>
        </div>

        <mat-form-field appearance="outline">
            <mat-label>Report Type</mat-label>
            <mat-select placeholder="Report Type" [formControlName]="'templateId'">
                <input (keyup)="onTemplateSearch($event.target.value)" class="py-3 p-2 w-full"
                    placeholder="Search report type">
                <mat-option *ngFor="let option of filteredTemplates" [value]="option.id">
                    {{ option.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Note</mat-label>
            <input matInput [formControlName]="'note'">
        </mat-form-field>

        <div class="w-full px-3 md:mb-0 pb-3">
            <div class="flex flex-wrap">
                <mat-checkbox [formControlName]="'bankId'" (change)="onCheckBoxSelectionBank($event)">Bank
                    Wise</mat-checkbox>
                <mat-checkbox class="pl-2" [formControlName]="'reportType'" (change)="onCheckBoxSelectionReportType($event)">Report
                    Type</mat-checkbox>
            </div>
        </div>

        <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4 sm:mt-6">
            <div class="-ml-2">

            </div>

            <div class="flex items-center sm:mt-0">
                <div class="flex ">
                    <button class="order-first sm:order-last" mat-flat-button [color]="'primary'"
                        (click)="onFileDownload(true)">
                        Generate Report In System
                    </button>

                </div>
                <!-- <div class="flex pl-2 ">
                    <button class="order-first sm:order-last" mat-flat-button [color]="'primary'" (click)="onFileDownload(false)" *ngIf="inward.googleDrivePath != null">
                        Generate Report In Drive
                    </button>

                </div> -->
                <div class="flex pl-2">
                    <button class="order-first sm:order-last" mat-flat-button [color]="'primary'"
                        *ngIf="googleDrivePath" (click)="onFileDownload(false)">
                        Generate Report In Drive
                    </button>
                </div>
            </div>
        </div>
    </form>
</div>
